import React from 'react';
import { Linkedin, Mail, Github, Twitter } from 'lucide-react';
import BrandLogo from './BrandLogo';

const footerLinks = {
  Product: [
    { name: 'AI Chat', href: '/chat' },
    { name: 'API Platform', href: '/docs' },
    { name: 'Enterprise', href: '#enterprise' },
    { name: 'Pricing', href: '#' },
  ],
  Developers: [
    { name: 'Documentation', href: '/docs' },
    { name: 'API Reference', href: '/docs' },
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Status', href: '#' },
  ],
  Company: [
    { name: 'About', href: '#company' },
    { name: 'Blog', href: '/blog' },
    { name: 'Careers', href: '#' },
    { name: 'Contact', href: '#' },
  ],
  Legal: [
    { name: 'Privacy', href: '#' },
    { name: 'Terms', href: '#' },
    { name: 'Security', href: '#' },
  ],
};

const socials = [
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: 'https://www.linkedin.com/company/opensov', label: 'LinkedIn' },
  { icon: Github, href: '#', label: 'GitHub' },
  { icon: Mail, href: '#', label: 'Email' },
];

const Footer = () => (
  <footer className="border-t border-line bg-app-alt" data-testid="footer-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 lg:py-20">
      <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
        <div className="col-span-2 md:col-span-4">
          <BrandLogo className="h-10" />
          <p className="mt-5 text-content-2 text-sm leading-relaxed max-w-xs">
            Sovereign intelligence. Built to last.
          </p>
          <div className="mt-6 flex gap-4">
            {socials.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="text-content-3 hover:text-content transition-colors duration-300"
                data-testid={`footer-${label.toLowerCase()}`}
                aria-label={label}
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        {Object.entries(footerLinks).map(([category, links]) => (
          <div key={category} className="md:col-span-2">
            <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-content-3 mb-5">{category}</p>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-content-2 text-sm hover:text-content transition-colors duration-300">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-16 pt-6 border-t border-line flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-content-3 text-[11px] font-mono tracking-wider">
          &copy; {new Date().getFullYear()} OpenSov AI. All rights reserved.
        </p>
        <a
          href="https://mbtventures.in"
          target="_blank"
          rel="noopener noreferrer"
          className="text-content-3 text-[11px] font-mono tracking-wider hover:text-content transition-colors"
        >
          A part of MBT Ventures
        </a>
        <a
          href="https://www.producthunt.com/products/opensov?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-opensov"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="product-hunt-badge"
        >
          <img
            alt="OpenSov on Product Hunt"
            width="180"
            height="40"
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1080042&theme=dark&t=1771218116311"
            className="opacity-60 hover:opacity-100 transition-opacity duration-300"
          />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
